import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";

export default {
	__defaultSheetProp: {
		vuwType: "sheet",
		selector() {
			return $("<var/>").appendTo(this.container.$self);
		}
	},
	__defaultSheetBtns: {
		prev: {
			text: "prev",
			func: function prev(btnElm) {	// thisはvuwSheet
				const vuwForm = this.container;
				vuwForm.setActiveSheet(vuwForm.getActiveSheetIdx() - 1);
			}
		},
		reset: {
			text: "reset",
			func: function reset(btnElm) {	// thisはvuwSheet
				this.clearVal();
			}
		},
		next: {
			text: "next",
			func: function next(btnElm) {	// thisはvuwSheet
				const $btnElm = this.$btns.children().addClass("is-disable");
				
				clearTimeout( $.data(btnElm, "execTimer") );
				$.data( btnElm, "execTimer", setTimeout(async () => {
					if( this.validate().count ) {
						$btnElm.removeClass("is-disable");
						return false;
					}
					
					await this.container.aNextStep();
					$btnElm.removeClass("is-disable");
					return true;
				}, 100) );
			}
		}
	},
	
	/*----------------
	* 子VuwSheet用のデフォルト設定の取得
	**/
	getDefaultSheetProp(sheetName) {
		// 基本設定
		const prop = {
			inpsStyle: this.config.inpsStyle || this.config.editFormStyle,
			inpsStyleOption: this.config.inpsStyleOption || this.config.editFormStyleOption,
			btns: {},
			...this.__defaultSheetProp
		};
		
		Object.keys(this.__defaultSheetBtns).forEach(k => {
			let v = this.__defaultSheetBtns[k];
			if( u_.isObject(v) ) {
				v = Object.assign({}, v);
			}
			prop.btns[k] = v;
		});
		
		// apply config.btnText object
		if( u_.isObject(this.config.btnText) ) {
			Object.keys(this.config.btnText).forEach(k => {
				if( prop.btns[k] && u_.isString(this.config.btnText[k]) ) {
					prop.btns[k].text = this.config.btnText[k];
				}
			});
		}
		
		// sheetNameごとの処理
		switch(sheetName) {
			case this.confirmSheetName: {
				// リセットボタンは不要
				delete prop.btns.reset;
				
				// setState("copy", VuwSheet) で入力リストをコピーする
				prop.onChangeState = async function(state) {
					if( state.copy instanceof Klass("VuwSheet") ) {
						await this.get(state.copy.name).setState({
							$elm: this.container._copySheetFrom(state.copy)
						});
						
						delete state.copy;
					}
				};
				
				// for paramSet
				prop.childProp = {
					selector() {
						return $("<var/>").insertBefore(this.container.$btns);
					},
					render($elm, state) {
						if( state.$elm instanceof $ ) {
							$elm = state.$elm;
						}
						return $elm;
					}
				};
				
				prop.renderComplete = ($self) => {
					// execボタン
					const $btnExec = $self.find(".btn-next").addClass("btn-exec");
					if(u_.isObject(this.config.btnText) && this.config.btnText.exec) {
						$btnExec.children("span").html( $.parseHTML(this.config.btnText.exec) );
					}
					
					// confirmボタン
					const $btnConfirm = $self.prev(".vuw-sheet").find(".btn-next").addClass("btn-confirm");
					if(u_.isObject(this.config.btnText) && this.config.btnText.confirm) {
						$btnConfirm.children("span").html( $.parseHTML(this.config.btnText.confirm) );
					}
				};
				
				break;
			}
			
			case this.finishSheetName: {
				// ボタンなし
				prop.btns = false;
				
				// finishMessage
				!!this.config.finishMessage && (prop.onReady = function($self) {
					if( Array.isArray(this.container.config.finishMessage) ) {
						this.container.config.finishMessage = this.container.config.finishMessage.join("\n");
					}
					
					let $finMsg;
					if( (/^#/).test(this.container.config.finishMessage) ) {
						// id指定されている場合はDOM取得
						$finMsg = $(this.container.config.finishMessage);
						!$finMsg.length && ($finMsg = false);
					}
					
					!$finMsg && ( $finMsg = $("<div/>").html(
						$.parseHTML( u_.textareaParse(this.container.config.finishMessage, true) )
					) );
					
					!!$finMsg && $finMsg.addClass("finish-message").prependTo( $self );
				});
				
				break;
			}
			
			default: {
				// inputs sheet
				if( u_.isObject(this.config.sheet[sheetName]) ) {
					// dataParams
					prop.dataParams = {};
					if( Array.isArray(this.config.sheet[sheetName].dataParams) ) {
						this.config.sheet[sheetName].dataParams.forEach(pk => {
							prop.dataParams[pk] = this.config.dataParams[pk] || {};
						});
					}
					
					// title
					!!this.config.sheet[sheetName].title && (prop.title = this.config.sheet[sheetName].title);
				}
				
				break;
			}
		}
		
		return prop;
	}
};
